module.exports = __webpack_public_path__ + "static/media/mkmp_logo.598a86cc.png";